<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="input_value = $event"
    :data="estados"
    :serializer="(item) => item.sigla"
    :placeholder="placeholder"
    :class="[stateClass]"
    :showOnFocus="true"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
    return_object: false,
    placeholder: {
      type: String,
      default: "UF",
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    input_value: null,
    estados: [],
  }),
  computed: {},
  methods: {
    ...mapActions("municipios", ["ActionGetAllEstados"]),
    setBySigla(sigla) {
      const selected = _.find(this.estados, { sigla: sigla });
      if (selected) {
        this.search = selected.sigla;
        this.input_value = selected;
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.$emit("input", null);
      }
    },
    input_value() {
      if (this.return_object) {
        this.$emit("input", this.input_value);
      } else {
        this.$emit("input", this.input_value.sigla);
      }
    },
    value: function (value, oldValue) {
      if (value && value !== this.search) this.setBySigla(value);
    },
  },
  async created() {
    this.estados = await this.ActionGetAllEstados();
    if (this.value) {
      this.setBySigla(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0;
  padding-left: 0;
  padding-top: 0;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
